import { z } from "zod";

export const getSivDataCarIconsToReviewResponseSchema = z.array(
  z.object({
    uuid: z.uuid(),
    brand: z.string(),
    model: z.string(),
    year: z.number().int(),
    color: z.string(),
    bucketFileName: z.string().nullable(),
  }),
);

export type GetSivDataCarIconsToReviewResponse = z.infer<
  typeof getSivDataCarIconsToReviewResponseSchema
>;
